export default __webpack_public_path__ + "static/media/0017.c362e1b4.png";